import { DefaultDeviceOptions } from "./constants/DevicesConstants";

export const getAppearanceStyle = deviceType => [
  { text: "Stack", value: "stack", class: "inlineDispayOpt singleMode" },
  { text: "List", value: "list", class: "inlineDispayOpt listMode" },
  ...(deviceType === DefaultDeviceOptions.web.value
    ? [{ text: "Slider", value: "slider", class: "inlineDispayOpt sliderMode" }]
    : []),
];
